import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { newUuid } from '@ark-libs/ngx-utils';

@Injectable({ providedIn: 'root' })
export class SubscriptionManager {
    private _componentRegisters: { [componentType: string]: number } = {};
    private _allSubscriptions: { [componentUUID: string]: Subscription[] } = {};

    constructor() { }

    register(component: any, subscription: Subscription) {
        if (component == null) return;

        let componentUUID = component;
        if (component instanceof Object) {
            componentUUID = component["componentUUID"];
            if (componentUUID == null) {
                const componentType = component.constructor.name;
                let componentCount = this._componentRegisters[componentType] || 0;
                componentUUID = componentType + "::" + (componentCount++) + "::" + newUuid();
                this._componentRegisters[componentType] = componentCount;
                component["componentUUID"] = componentUUID;
            }
        }

        let subscriptions = this._allSubscriptions[componentUUID];
        if (subscriptions == null) {
            subscriptions = [];
            this._allSubscriptions[componentUUID] = subscriptions;
        }
        subscriptions.push(subscription);
        // console.log("SubscriptionManager.register("+componentUUID+")  --> index=", subscriptions.length);
    }
    unsubscribe(component: any) {
        let componentUUID = component;
        if (component instanceof Object && component != null) componentUUID = component["componentUUID"];
        if (componentUUID == null) return;

        let subscriptions = this._allSubscriptions[componentUUID];
        if (subscriptions) {
            // console.log("SubscriptionManager.unsubscribe("+componentUUID+")  --> count=", subscriptions.length);
            subscriptions.forEach(subscription => {
                try { subscription.unsubscribe(); } catch (e) { }
            });
            delete this._allSubscriptions[componentUUID];
        }
    }
}
